import CircularBold from './lineto-circular-bold-c.woff';
import CircularBook from './lineto-circular-book-c.woff';

export default {
  CircularBook,
  CircularBold
};
